import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createStore } from "redux";
import reducer from "./reducers/rootReducer";
import { Provider } from "react-redux";
import Routers from "./Routers";

// require("dotenv").config();
const store = createStore(reducer);
//
// <,

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Routers />
  </Provider>
);
